import { pivotData, getDistinctAttributeValues, addDerivedCols } from "../utilities/utilFunctions";
import {getCountByYear,getCountByLocYear,getTraitAverages} from './api'
const backendurl = process.env.REACT_APP_EXLIBRIS_SERVICE;

const constructURL = async (dbCode, dataType) => {
  //console.log("Filter Options in request creation ",filterOptions)
   let url = '';

    if (dataType === 'raw') {
        url = `${backendurl}/rawdata`;
    } 
    else if (dataType === 'means' || dataType === 'blups') {
        url = `${backendurl}/meansdata`;
    } 
    else if (dataType === 'expt') {
        url = `${backendurl}/exptdata`;
    }
    else if (dataType==='rawLines'){
      url = `${backendurl}/rawdataselectedlines`;
    }
    else if(dataType==='meansLines'){
      url = `${backendurl}/meansdataselectedlines`;
    }

    const queryParams = new URLSearchParams();
    queryParams.append('dbCode', dbCode);

    // Ensure each parameter is always treated as an array
    /*const appendArrayParams = (key, values) => {
        if (!Array.isArray(values)) values = values ? [values] : []; // Force single value to array
        values.forEach(value => queryParams.append(`${key}[]`, value)); // Append [] to key to ensure array format
    };
    // Append all filter options ensuring array treatment
    appendArrayParams('years', filterOptions.Years);
    appendArrayParams('expt', filterOptions.Experiments);
    appendArrayParams('locs', filterOptions.Locations);
    appendArrayParams('traits', filterOptions.Traits);
    appendArrayParams('lines',filterOptions.Lines)*/
    const finalUrl = `${url}?${queryParams.toString()}`;
    
    return finalUrl;
};

const transformData=async(response,dataType,dbCode)=>{
    if (response.error) {
        throw new Error(response.message);
    }
    if (dataType === 'expt') {
        return response;
    }
    else if (['raw', 'means', 'rawLines', 'meansLines'].includes(dataType)) {
        if (!response.error) {
          const pivotedData = pivotData(response.data);
          if(dataType === 'raw' || dataType === 'rawLines'){
            if(response.isDerived){
              addDerivedCols(pivotedData, dbCode);
            }
          }
          return { error: false, message: 'Success', data: pivotedData };
        }else {
          throw new Error('Error trying to fetch data');
        }
    }
    else if (dataType === 'blups') {
        if (!response.error) {
          const result = {}
          result.error = false;
          const pivotedData = pivotData(response.data);
          result.data = pivotedData
          const traits = getDistinctAttributeValues(response.data, 'TRAIT');
          result.traits = traits
          const years = getDistinctAttributeValues(response.data, 'YEAR');
          result.years = years;
          if (pivotedData.length > 0) {
            const countByYearResponse = await getCountByYear(traits, pivotedData);
            if (!countByYearResponse.error) {
              result.countByYear = countByYearResponse.data
            }
            else {
              result.countByYear = null
            }
            const countByLocYearResponse = await getCountByLocYear(traits, pivotedData);
            if (!countByLocYearResponse.error) {
              result.countByLocYear = countByLocYearResponse.data
            }
            else {
              result.countByLocYear = null
            }
            const traitAverageResponse = await getTraitAverages(traits, pivotedData);
            if (!traitAverageResponse.error) {
              result.traitAverage = traitAverageResponse.data
            }
            else {
              result.traitAverage = null
            }
            return result
          }
          else {
            throw new Error('Query returned no data')
          }
        }
      }
}



export {constructURL,transformData}